export default function HeroSection() {
  const mainSiteUrl = 'https://kaspreadsheet.com';

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20scene%20with%20fashion%20sneakers%20and%20accessories%20arranged%20on%20warm%20cream%20marble%20surface%2C%20soft%20natural%20daylight%20from%20window%2C%20pastel%20aesthetic%2C%20editorial%20lifestyle%20composition%2C%20sage%20green%20and%20terracotta%20accent%20decor%20elements%2C%20gentle%20shadows%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20Scandinavian%20inspired%20styling%2C%20no%20text%20overlay&width=1600&height=900&seq=kakobuy-hero-01&orientation=landscape"
          alt="Kakobuy Spreadsheet - kolekcja produktów"
          title="Kakobuy Spreadsheet Polska 2026 - produkty i kategorie"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-white mb-4 leading-tight">
          Kakobuy Spreadsheet Polska –<br />
          <span className="text-white/90">Najlepsza Baza Produktów i Linków Zakupowych 2026</span>
        </h1>
        <p className="text-sm md:text-base text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          Znajdź najlepsze produkty z Chin szybciej dzięki aktualizowanym listom Kakobuy Spreadsheet.
          Buty, streetwear, moda, akcesoria i najpopularniejsze produkty w jednym miejscu.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
          >
            Kakobuy Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 font-semibold rounded-full text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-white/25 transition-all duration-200"
          >
            Buy It Now
            <i className="ri-shopping-cart-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 mt-8 text-xs md:text-sm text-white/70">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400"></i> Aktualizowane codziennie
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400"></i> Lista popularnych produktów
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400"></i> Poradniki dla Polski
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400"></i> Bezpieczeństwo
          </span>
        </div>
      </div>
    </section>
  );
}